import axios from '../axiosClient';
// eslint-disable-next-line import/prefer-default-export
export const sendRefundRequest = async (data) => axios.post('/api/invoicing/refund-request', data);
export const getRefundRequest = async () => axios.get('/api/invoicing/refund-request');
